import React, { useEffect, useState } from "react";
import { Button, Spacer, useTheme } from "@ugc-ui/lego";
import { observer } from "mobx-react-lite";
import { useStores } from "@client/store";
import { useNavigate } from "react-router-dom";
import { Path } from "@src/common/consts/Path";
import { Nullable } from "@src/common/typings/common";
import { useLottie } from "@src/common/hooks/useLottie";
import { Lottie } from "@src/common/components/Lottie/Lottie";
import { Modal } from "@src/common/components/Modal/Modal";
import { ModalContentWrapper } from "@src/common/components/Modal/ModalTemplate/ModalContentWrapper/ModalContentWrapper";
import { FlexFieldsContainer } from "@client/pages/Home/InitialDialog/InitialDialog.styled";
import { useIsMobile } from "@src/common/hooks/isMobile";
import {
  DialogActionsStyled,
  MessageText,
  StyledFlex,
  StyledFlexButtons,
  StyledHref,
  TypographyStyled,
} from "@src/client/pages/AcessDeniedPage.styled";
import { config } from "@src/config";

export const AccessDeniedPage = observer(() => {
  const navigate = useNavigate();
  const {
    client: {
      authStore: { redirectToAccessDenied },
    },
  } = useStores();
  const isMobile = useIsMobile();

  const theme = useTheme();

  const [lottieContainer, setLottieContainer] =
    useState<Nullable<HTMLDivElement>>(null);

  useLottie("/lottie/451.json", lottieContainer);

  useEffect(() => {
    if (!redirectToAccessDenied) {
      navigate(Path.TO_HOME);
    }
  });

  return (
    <div>
      <Modal
        isOpen
        dataCy="диалоговое окно Данные о рекламодателе"
        fullScreen={isMobile}
      >
        <ModalContentWrapper fullScreen={isMobile}>
          <FlexFieldsContainer fullScreen={isMobile}>
            <StyledFlex>
              <Lottie ref={setLottieContainer} />
            </StyledFlex>

            <StyledFlex>
              <TypographyStyled>
                Ой... Ты не можешь зайти в рекламный кабинет
              </TypographyStyled>
            </StyledFlex>
            <StyledFlex>
              <MessageText color={theme.gray.a60} type="subtitle1">
                У тебя нет необходимых прав для доступа в рекламный кабинет
              </MessageText>
            </StyledFlex>
          </FlexFieldsContainer>
          <DialogActionsStyled>
            <StyledFlexButtons fullScreen={isMobile}>
              <StyledHref
                href="https://t.me/yappyhelpbot"
                target="_blank"
                rel="noreferrer"
                fullScreen={isMobile}
              >
                <Button
                  startIcon="telegram"
                  fullWidth
                  variant="outlined"
                  color="primary"
                  theme={theme}
                >
                  Написать в поддержку
                </Button>
              </StyledHref>

              <Spacer size={10} />

              <StyledHref
                href={`${config.WEB_VERSION_URL}/feed`}
                rel="noreferrer"
                fullScreen={isMobile}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  color="default"
                  theme={theme}
                >
                  Перейти к ленте
                </Button>
              </StyledHref>
            </StyledFlexButtons>
          </DialogActionsStyled>
        </ModalContentWrapper>
      </Modal>
    </div>
  );
});
